module.exports = __webpack_public_path__ + "static/img/云平台.b219216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/云平台.png
// module id = E6uF
// module chunks = 1